import { FC, useCallback, useId } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { CheckboxInput } from 'components/Checkbox'
import { FlexDivCentered } from 'components/layout/flex'
import { Body } from 'components/Text'
import { SuggestedBadge } from 'sections/shared/components/SelectTradingType'
import { selectTradingMode } from 'state/futures/common/selectors'
import { setTradingMode } from 'state/futures/reducer'
import { TradingModes } from 'state/futures/types'
import { useAppDispatch, useAppSelector } from 'state/hooks'

type Props = {
	label?: string
}

const OneClickCheckbox: FC<Props> = ({ label }) => {
	const { t } = useTranslation()
	const dispatch = useAppDispatch()
	const id = useId()
	const isOneClickEnabled = useAppSelector(selectTradingMode) === TradingModes.ONE_CLICK

	const toggleTradingMode = useCallback(() => {
		dispatch(setTradingMode(isOneClickEnabled ? TradingModes.DEFAULT : TradingModes.ONE_CLICK))
	}, [dispatch, isOneClickEnabled])

	return (
		<Container>
			<CheckboxInput
				type="checkbox"
				color="default"
				name={id}
				checked={isOneClickEnabled}
				onChange={toggleTradingMode}
				variant="tick"
				id={id}
				style={{ flex: '0 0 20px' }}
			/>
			<Label htmlFor={id}>
				<Body size="medium" weight="bold">
					{label || t('futures.one-click-trading.open-trade')}
				</Body>
				<SuggestedBadge />
			</Label>
		</Container>
	)
}

const Container = styled(FlexDivCentered)`
	gap: 10px;
	justify-content: flex-start;
	padding-bottom: 10px;
	border-bottom: ${(props) => props.theme.colors.selectedTheme.border};
`

const Label = styled.label`
	display: flex;
	align-items: center;
	flex: 1;
	cursor: pointer;
	gap: 10px;
`

export default OneClickCheckbox
